export type DirectMessageIdentity = { name: string; avatar_url: string | null };
export type DirectMessageParticipants = {
  users?: (DirectMessageIdentity & { user_id: number })[];
  self?: DirectMessageIdentity & { user_id: number };
};

/** Reuse conversation/account data; sending a message never triggers a profile request. */
export function directMessageIdentity(
  sender: { org_id: number; user_id: number } | undefined,
  participants: DirectMessageParticipants | undefined,
): DirectMessageIdentity | undefined {
  if (!sender || !participants) return undefined;
  const user = participants.users?.find(user => user.user_id === sender.user_id);
  if (user) return user;
  if (sender.user_id === participants.self?.user_id) return participants.self;
  return undefined;
}
